export default __webpack_public_path__ + "static/media/homeArt.aca38c1a.png";